import axios from "axios";
import authHeader from "./auth-header";
import { BASE_URL } from "./config";

export const getCases = () => {
  try {
    return axios.get(BASE_URL + "cases/getCases", { headers: authHeader() });
  } catch (e) {
    console.log(e);
  }
};

export const sendCompanySearch = (company) => {
  try {
    return axios.post(BASE_URL + "cases/search", { company_name: company });
  } catch (e) {
    console.log(e);
  }
};

export const sendCompanySearchBackUp = (company) => {
  try {
    return axios.post(BASE_URL + "cases/backup_search", {
      company_name: company,
    });
  } catch (e) {
    console.log(e);
  }
};

export const validateURL = (url) => {
  try {
    return axios.post(BASE_URL + "cases/validateURL", { url: url });
  } catch (e) {
    console.log(e);
  }
};

export const saveCase = (caseName, domain) => {
  try {
    return axios.post(
      BASE_URL + "cases/saveCase",
      { caseName, domain },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getClipboardTerms = () => {
  try {
    return axios.get(BASE_URL + "saved/getRecentClipboardTerms", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const addToClipboard = (term) => {
  try {
    return axios.post(
      BASE_URL + "saved/addClipboardTerm",
      { term },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const deleteFromClipboard = (term) => {
  try {
    return axios.post(
      BASE_URL + "saved/deleteClipboardTerm",
      { term },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getDocIdData = (document_id) => {
  try {
    return axios.get(
      BASE_URL + "cases/getDocIdData?document_id=" + document_id,
      {
        headers: authHeader(),
      },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getDocsbyIds = (doc_ids) => {
  try {
    return axios.get(BASE_URL + "chat/getDocsbyIds?doc_ids=" + doc_ids, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getDocsbyUrls = (urls) => {
  try {
    return axios.get(BASE_URL + "chat/getDocsbyUrls?urls=" + urls, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};
